export default __webpack_public_path__ + "static/media/ceo.704629e9.jpeg";